<script>
import LoadingIndicator from '@/Components/Utilities/LoadingIndicator.vue'
import {useWindowSize} from '@vueuse/core'

const {width} = useWindowSize()

export default {
    components: { LoadingIndicator },
    props: {
        menuCollapsed: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        navCollapsed: {},
        navCollapsedSaving: {},
        changeIcons: {
            'fa-file-o': 'far fa-file'
        }
    }),
    computed: {
        sideMenuCollapsed() {
            return this.menuCollapsed || width.value < 1024
        }
    },
    mounted() {
        this.navCollapsed = this.$page.props.auth.user.NavCollapseState ? typeof this.$page.props.auth.user.NavCollapseState === 'object' ? this.$page.props.auth.user.NavCollapseState : JSON.parse(this.$page.props.auth.user.NavCollapseState) : {}
    },
    methods: {
        getMenu() {
            return this.$page.props.sideNav.menu.filter((item) => {
                return ![1, 135, 136, 137].includes(item.id)
            })
        },
        getMenuUrl(menuItem) {
            let version = this.$page.props?.uiVersion ?? 5
            switch (version) {
            case 6:
                return menuItem.v6PageToLink ? '/' + menuItem.v6PageToLink : '/' + menuItem.PageToLink
            case 5:
                return '/' + menuItem.PageToLink
            }
        },
        getNonModules() {
            return this.$page.props.sideNav.nonModules
        },
        getModules() {
            return this.$page.props.sideNav.modules
        },
        getHistory() {
            return this.$page.props.sideNav.history
        },
        setNavCollapseState(id, state) {
            this.navCollapsed[id] = state
            this.navCollapsedSaving[id] = true
            axios.post(route('nav.collapse'), {
                nav_collapsed_array: this.navCollapsed
            }).then(() => {
                this.navCollapsedSaving[id] = false
            })
        }
    }
}
</script>

<template>
    <div class="text-sm text-white">
        <ul class="mt-2 text-rss-nav-blue">
            <li class="group relative">
                <!--                    <inertia-link href="/"-->
                <!--                        class="flex items-center w-full px-4 py-2.5 space-x-4 text-spotler-gray-100"-->
                <!--                        :class="{ 'justify-center': sideMenuCollapsed }"-->
                <!--                    >-->
                <a
                    :class="{ 'justify-center': sideMenuCollapsed }"
                    class="flex items-center py-2.5 px-4 space-x-4 w-full text-spotler-gray-100"
                    href="/"
                >
                    <i class="w-4 text-center fa fa-tachometer-alt" />
                    <span
                        v-if="!sideMenuCollapsed"
                        class="leading-none"
                    >{{
                        __('Dashboard')
                    }}</span>
                </a>
                <!--                    </inertia-link>-->
                <div
                    v-if="sideMenuCollapsed"
                    class="absolute top-0 right-px z-40 py-2.5 px-4 -ml-px leading-none text-white whitespace-nowrap bg-rss-dark-blue rounded-r shadow opacity-0 group-hover:opacity-100 transition translate-x-full pointer-events-none"
                >
                    {{ __('Dashboard') }}
                </div>
            </li>
            <li
                v-for="menu in getMenu()"
                :key="menu.id"
                class="group relative"
            >
                <!--                <inertia-link :href="$route('record.index', menu.PageToLink)"-->
                <!--                    class="flex items-center w-full px-4 py-2.5 space-x-4 text-spotler-gray-100"-->
                <!--                    :class="{ 'justify-center': sideMenuCollapsed, 'text-white ': $route().params.page == menu.PageToLink }"-->
                <!--                >-->
                <a
                    :class="{
                        'justify-center': sideMenuCollapsed,
                        'bg-spotler-honesty text-white':
                            $route().params.page == menu.PageToLink
                    }"
                    :dusk="'SideNav' + menu.Name"
                    :href="getMenuUrl(menu)"
                    class="flex items-center py-2.5 px-4 space-x-4 w-full text-spotler-gray-100"
                >
                    <i
                        :class="
                            'fa  w-4 text-center ' +
                                (menu.Icon ||
                                    $page.props.icons[menu.Name.toLowerCase()])
                        "
                    />
                    <span
                        v-if="!sideMenuCollapsed"
                        class="leading-none"
                    >{{
                        __(menu.Name)
                    }}</span>
                </a>
                <!--                </inertia-link>-->
                <div
                    v-if="sideMenuCollapsed"
                    class="absolute top-0 right-px z-40 py-2.5 px-4 -ml-px leading-none text-white whitespace-nowrap bg-rss-dark-blue rounded-r shadow opacity-0 group-hover:opacity-100 transition translate-x-full pointer-events-none"
                >
                    {{ menu.Name }}
                </div>
            </li>
        </ul>

        <template
            v-for="(menus, name) in getNonModules()"
            :key="name"
        >
            <div v-if="menus.length > 0">
                <div
                    v-if="!menuCollapsed"
                    class=""
                >
                    <button
                        class="group flex justify-between items-center px-4 mt-6 mb-2 w-full focus:outline-none"
                        @click="
                            setNavCollapseState(
                                menus[0]?.ParentId.toString(),
                                navCollapsed[menus[0]?.ParentId.toString()] !== undefined
                                    ? !navCollapsed[menus[0]?.ParentId.toString()]
                                    : false
                            )
                        "
                    >
                        <span
                            v-if="menus.length > 0"
                            class="text-xs font-bold text-spotler-gray-100 uppercase opacity-60"
                        >{{ __(name) }}</span>
                        <loading-indicator
                            v-if="navCollapsedSaving[menus[0]?.ParentId.toString()]"
                            :loading="navCollapsedSaving[menus[0]?.ParentId.toString()]"
                            indicator-classes="w-4 lg:mr-1"
                        />
                        <span
                            v-else
                            class="hidden group-hover:block text-3xs font-bold focus:outline-none opacity-75"
                            v-text="
                                (
                                    navCollapsed[menus[0]?.ParentId.toString()] !== undefined
                                        ? navCollapsed[menus[0]?.ParentId.toString()]
                                        : true
                                )
                                    ? 'HIDE'
                                    : 'SHOW'
                            "
                        />
                    </button>
                </div>
                <div
                    v-else
                    class="group flex relative justify-center items-center py-2.5 px-4 mt-6"
                >
                    <i
                        class="text-spotler-gray-100 opacity-60 fa"
                        :class="$page.props.icons[name.toLowerCase()]"
                    />
                    <div
                        v-if="menuCollapsed"
                        class="absolute top-0 right-px z-40 py-2.5 px-4 -ml-px leading-none text-white whitespace-nowrap bg-rss-dark-blue rounded-r shadow opacity-0 group-hover:opacity-100 transition translate-x-full pointer-events-none"
                    >
                        {{ name }}
                    </div>
                </div>
                <ul
                    v-if="
                        (navCollapsed[menus[0]?.ParentId.toString()] !== undefined
                            ? navCollapsed[menus[0]?.ParentId.toString()]
                            : true) === true
                    "
                    class="text-rss-nav-blue"
                >
                    <li
                        v-for="menu in menus"
                        :key="menu.id"
                        class="group relative"
                    >
                        <!--                    <inertia-link :href="$route('record.index', menu.PageToLink)"-->
                        <!--                        class="flex items-center w-full px-4 py-2.5 space-x-4 text-spotler-gray-100"-->
                        <!--                        :class="{ 'justify-center': menuCollapsed, 'text-white ': $route().params.page == menu.PageToLink }"-->
                        <!--                    >-->
                        <a
                            :href="getMenuUrl(menu)"
                            class="flex items-center py-2.5 px-4 space-x-4 w-full text-spotler-gray-100"
                            :dusk="'SideNav' + menu.Name"
                            :class="{
                                'justify-center': menuCollapsed,
                                'text-white':
                                    $route().params.page === menu.PageToLink
                            }"
                        >
                            <i
                                :class="
                                    'fa  w-4 text-center ' +
                                        (changeIcons[menu.Icon] ? changeIcons[menu.Icon] : menu.Icon ||
                                            $page.props.icons[menu.Name.toLowerCase()] || 'fa-external-link')
                                "
                            />
                            <span
                                v-if="!menuCollapsed"
                                class="leading-none"
                            >{{
                                __(menu.Name)
                            }}</span>
                        </a>
                        <!--                    </inertia-link>-->
                        <div
                            v-if="menuCollapsed"
                            class="absolute top-0 right-px z-40 py-2.5 px-4 -ml-px leading-none text-white whitespace-nowrap bg-rss-dark-blue rounded-r shadow opacity-0 group-hover:opacity-100 transition translate-x-full pointer-events-none"
                        >
                            {{ menu.Name }}
                        </div>
                    </li>
                </ul>
            </div>
        </template>

        <div
            v-for="module in getModules()"
            :key="module.id"
        >
            <div
                v-if="!sideMenuCollapsed"
                class=""
            >
                <button
                    v-if="module.menus.length > 0"
                    class="group flex justify-between items-center px-4 mt-6 mb-2 w-full focus:outline-none"
                    @click="
                        setNavCollapseState(
                            module.menus[0]?.ParentId.toString(),
                            navCollapsed[module.menus[0]?.ParentId.toString()] !== undefined
                                ? !navCollapsed[module.menus[0]?.ParentId.toString()]
                                : false
                        )
                    "
                >
                    <span
                        class="text-xs font-bold text-spotler-gray-100 uppercase opacity-60"
                    >{{ __(module.Name) }}</span>
                    <loading-indicator
                        v-if="navCollapsedSaving[module.menus[0]?.ParentId.toString()]"
                        :loading="navCollapsedSaving[module.menus[0]?.ParentId.toString()]"
                        indicator-classes="w-4 lg:mr-1"
                    />
                    <span
                        v-else
                        class="hidden group-hover:block text-3xs font-bold focus:outline-none opacity-75"
                        v-text="
                            (
                                navCollapsed[module.menus[0]?.ParentId.toString()] !== undefined
                                    ? navCollapsed[module.menus[0]?.ParentId.toString()]
                                    : true
                            )
                                ? 'HIDE'
                                : 'SHOW'
                        "
                    />
                </button>
            </div>
            <div
                v-else
                class="group flex relative justify-center items-center py-2.5 px-4 mt-6"
            >
                <i
                    :class="$page.props.icons[module.Name.toLowerCase()]"
                    class="text-spotler-gray-100 opacity-60 fa"
                />
                <div
                    v-if="sideMenuCollapsed"
                    class="absolute top-0 right-px z-40 py-2.5 px-4 -ml-px leading-none text-white whitespace-nowrap bg-rss-dark-blue rounded-r shadow opacity-0 group-hover:opacity-100 transition translate-x-full pointer-events-none"
                >
                    {{ module.Name }}
                </div>
            </div>
            <ul
                v-if="
                    (navCollapsed[module.menus[0]?.ParentId.toString()] !== undefined
                        ? navCollapsed[module.menus[0]?.ParentId.toString()]
                        : true) === true
                "
                class="text-rss-nav-blue"
            >
                <li
                    v-for="menu in module.menus"
                    :key="menu.id"
                    class="group relative"
                >
                    <!--                    <inertia-link :href="$route('record.index', menu.PageToLink)"-->
                    <!--                        class="flex items-center w-full px-4 py-2.5 space-x-4 text-spotler-gray-100"-->
                    <!--                        :class="{ 'justify-center': sideMenuCollapsed, 'text-white ': $route().params.page == menu.PageToLink }"-->
                    <!--                    >-->
                    <a
                        :class="{
                            'justify-center': sideMenuCollapsed,
                            'text-white':
                                $route().params.page === menu.PageToLink
                        }"
                        :dusk="'SideNav' + menu.Name"
                        :href="getMenuUrl(menu)"
                        class="flex items-center py-2.5 px-4 space-x-4 w-full text-spotler-gray-100"
                    >
                        <i
                            :class="
                                'fa  w-4 text-center ' +
                                    (changeIcons[menu.Icon] ? changeIcons[menu.Icon] : menu.Icon ||
                                        $page.props.icons[menu.Name.toLowerCase()] || 'fa-external-link')
                            "
                        />
                        <span
                            v-if="!sideMenuCollapsed"
                            class="leading-none"
                        >{{
                            __(menu.Name)
                        }}</span>
                    </a>
                    <!--                    </inertia-link>-->
                    <div
                        v-if="sideMenuCollapsed"
                        class="absolute top-0 right-px z-40 py-2.5 px-4 -ml-px leading-none text-white whitespace-nowrap bg-rss-dark-blue rounded-r shadow opacity-0 group-hover:opacity-100 transition translate-x-full pointer-events-none"
                    >
                        {{ menu.Name }}
                    </div>
                </li>
            </ul>
        </div>
        <div
            v-if="!sideMenuCollapsed"
            class=""
        >
            <button
                class="group flex justify-between items-center px-4 mt-6 mb-2 w-full focus:outline-none"
                @click="
                    setNavCollapseState(
                        'history',
                        navCollapsed['history'] !== undefined
                            ? !navCollapsed['history']
                            : false
                    )
                "
            >
                <span class="text-xs font-bold text-spotler-gray-100 uppercase opacity-60">{{ __('History') }}</span>
                <loading-indicator
                    v-if="navCollapsedSaving['history']"
                    :loading="navCollapsedSaving['history']"
                    indicator-classes="w-4 lg:mr-1"
                />
                <span
                    v-else
                    class="hidden group-hover:block text-3xs font-bold focus:outline-none opacity-75"
                    v-text="
                        (
                            navCollapsed['history'] !== undefined
                                ? navCollapsed['history']
                                : true
                        )
                            ? 'HIDE'
                            : 'SHOW'
                    "
                />
            </button>
        </div>
        <div
            v-else
            class="group flex relative justify-center items-center py-2.5 px-4 mt-6"
        >
            <i
                :class="$page.props.icons['history']"
                class="text-spotler-gray-100 opacity-60 fa"
            />
            <div
                v-if="sideMenuCollapsed"
                class="absolute top-0 right-px z-40 py-2.5 px-4 -ml-px leading-none text-white whitespace-nowrap bg-rss-dark-blue rounded-r shadow opacity-0 group-hover:opacity-100 transition translate-x-full pointer-events-none"
            >
                {{ __('History') }}
            </div>
        </div>
        <ul
            v-if="
                (navCollapsed['history'] !== undefined
                    ? navCollapsed['history']
                    : true) === true
            "
            class="mt-2 text-rss-nav-blue"
        >
            <li
                v-for="menu in getHistory()"
                :key="menu.id"
                class="group relative"
            >
                <a
                    v-if="menu.ItemType === 'Search'"
                    :class="{
                        'justify-center': sideMenuCollapsed,
                        ' text-white':
                            $route().params.page === menu.URL
                    }"
                    class="flex items-center py-2.5 px-4 space-x-4 w-full text-spotler-gray-100"
                    href="#"
                    @click="$emit('search', menu.Title)"
                >
                    <i
                        :class="
                            'fa  w-4 text-center ' +
                                (menu.Icon ||
                                    $page.props.icons[menu.ItemType.toLowerCase()] ||
                                    $page.props.icons.default
                                )
                        "
                    />
                    <span
                        v-if="!sideMenuCollapsed"
                        class="leading-none"
                    >{{
                        __(menu.Title)
                    }}</span>
                </a>
                <a
                    v-else
                    :class="{
                        'justify-center': sideMenuCollapsed,
                        ' text-white':
                            $route().params.page === menu.URL
                    }"
                    :href="menu.URL"
                    class="flex items-center py-2.5 px-4 space-x-4 w-full text-spotler-gray-100"
                >
                    <i
                        :class="
                            'fa  w-4 text-center ' +
                                (menu.Icon ||
                                    $page.props.icons[menu.ItemType.toLowerCase()] ||
                                    $page.props.icons.default
                                )
                        "
                    />
                    <span
                        v-if="!sideMenuCollapsed"
                        class="leading-none"
                    >{{
                        __(menu.Title)
                    }}</span>
                </a>
                <div
                    v-if="sideMenuCollapsed"
                    class="absolute top-0 right-px z-40 py-2.5 px-4 -ml-px leading-none text-white whitespace-nowrap bg-rss-dark-blue rounded-r shadow opacity-0 group-hover:opacity-100 transition translate-x-full pointer-events-none"
                >
                    {{ menu.Title }}
                </div>
            </li>
        </ul>
    </div>
</template>
